import { createApi } from '@reduxjs/toolkit/query/react'
import { rtkBaseQuery } from 'Src/api'

export const joinAccountApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'joinAccountApi',
  endpoints: (builder) => ({
    verifyToken: builder.query({
      query: (token) => `/v1/verify/${token}`
    }),
    acceptInvite: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/accept-invite',
          method: 'POST',
          body: payload
        }
      }
    })
  })
})

export const { useVerifyTokenQuery, useAcceptInviteMutation } = joinAccountApi

export default joinAccountApi
